import { Box, CircularProgress, DialogContentText } from "@mui/material";
import { ConfirmDialog, ResourceInfoDisplay } from "components/ConfirmDialog";
import { JobStepsDone } from "generated-graphql/graphql";

export interface DeleteStepConfirmDialogProps {
  open: boolean;
  stepToDelete: JobStepsDone | null;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  chemicalName: string | null;
  chemicalLoading: boolean;
}

function extractChemicalId(name: string | null | undefined): string | null {
  if (!name) {
    return null;
  }
  const match = name.match(/^chemical-([0-9a-fA-F-]{36})$/);
  return match ? match[1] : null;
}

export function DeleteStepConfirmDialog({
  open,
  stepToDelete,
  onClose,
  onConfirm,
  loading,
  chemicalName,
  chemicalLoading,
}: DeleteStepConfirmDialogProps) {
  const hasChemicalId = stepToDelete
    ? extractChemicalId(stepToDelete.name)
    : false;

  return (
    <ConfirmDialog
      open={open}
      header="Delete Job Step"
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      confirmText="Delete"
      cancelText="Cancel"
    >
      <DialogContentText sx={{ mb: 2 }}>
        Are you sure you want to delete this job step?
      </DialogContentText>

      {stepToDelete && (
        <Box sx={{ mb: 2 }}>
          <ResourceInfoDisplay
            resourceType="Step Name"
            resourceName={stepToDelete.name}
          />

          {hasChemicalId && (
            <>
              {chemicalLoading ? (
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
                >
                  <CircularProgress size={16} />
                  <DialogContentText>
                    Loading chemical name...
                  </DialogContentText>
                </Box>
              ) : chemicalName ? (
                <ResourceInfoDisplay
                  resourceType="Chemical Name"
                  resourceName={chemicalName}
                />
              ) : null}
            </>
          )}
        </Box>
      )}
    </ConfirmDialog>
  );
}
